import api from './axios';

export const login = async (email, password) => {
  const response = await api.post('/auth/login', { email, password });
  return response.data;
};

export const register = async (data) => {
  const response = await api.post('/auth/register', data);
  return response.data;
};

export const logout = async () => {
  await api.post('/auth/logout');
};

export const getUser = async () => {
  const response = await api.get('/auth/user');
  return response.data;
};

export const updateProfile = async (data) => {
  const response = await api.put('/auth/profile', data);
  return response.data;
};

export const changePassword = async (data) => {
  const response = await api.put('/auth/change-password', data);
  return response.data;
};

export const getAllUsers = async () => {
  const response = await api.get('/admin/users');
  return response.data;
};

export const createUser = async (data) => {
  const response = await api.post('/admin/users', data);
  return response.data;
};

export const updateUser = async (id, data) => {
  const response = await api.put(`/admin/users/${id}`, data);
  return response.data;
};

export const deleteUser = async (id) => {
  const response = await api.delete(`/admin/users/${id}`);
  return response.data;
};

export const getUserPermissions = async (id) => {
  const response = await api.get(`/admin/users/${id}/permissions`);
  return response.data;
};

export const setUserPermissions = async (id, features) => {
  const response = await api.put(`/admin/users/${id}/permissions`, { features });
  return response.data;
};

export const clearUserPermissions = async (id) => {
  const response = await api.delete(`/admin/users/${id}/permissions`);
  return response.data;
};

export const getRolePermissions = async () => {
  const response = await api.get('/admin/role-permissions');
  return response.data;
};

export const updateRolePermissions = async (data) => {
  const response = await api.post('/admin/role-permissions', data);
  return response.data;
};
